import DashboardIcon from '@repo/ui/components/icons/sidebar/DashboardIcon';
import MaintenanceIcon from '@repo/ui/components/icons/sidebar/MaintanceIcon';
import SupportIcon from '@repo/ui/components/icons/sidebar/ChatIcon';  
import TwoUsersIcon from '@repo/ui/components/icons/sidebar/TwoUsersIcon'; 
import AddClient from '@repo/ui/components/icons/AddClient';
import UsersIcon from '@repo/ui/components/icons/sidebar/UsersIcon';
import LocationIcon from '@repo/ui/components/icons/sidebar/LocationIcon'; 
import People from '@repo/ui/components/icons/People'; 
import { BarChart3, CircleDollarSign, Package } from 'lucide-react';

export const navigationBottom = [
    // { name: 'messages', icon: MessagesIcon, activeIcon: MessagesIcon, to: '' },
    {
        name: 'settings',
        icon: MaintenanceIcon,
        activeIcon: MaintenanceIcon,
        to: '/settings',
        // requiresPermission: 'list_setting',
    },
    // { name: 'help_and_support', icon: SupportIcon, activeIcon: SupportIcon, to: '' },
];

export const patientRelations = [
    {
        name: 'add_client',
        to: '/patient-relations/add-patient',
        // requiresPermission: 'create_customer',
    },
    { name: 'customer_communication', to: '/patient-relations/patient-communication' },
    // { name: 'archive', to: '/patient-relations/archive' },
];

// // Service
export const ReportsSide = [
    { name: 'customer', to: '/reports/patient' },
    { name: 'marketing', to: '/reports/marketing' },
    {
        name: 'checkup',
        to: '/reports/checkup',
    },
    {
        name: 'branches_and_employees',
        to: '/reports/branches-and-employees',
    },
];

export const navigation = [
    { name: 'dashboard', icon: DashboardIcon, activeIcon: DashboardIcon, to: '/' },
    {
        name: 'customer_relations',
        icon: TwoUsersIcon,
        activeIcon: TwoUsersIcon,
        to: '/patient-relations',
        navigation: patientRelations,
        // requiresPermission: 'list_customer',
    },

    {
        name: 'checkup',
        icon: AddClient,
        activeIcon: AddClient,
        to: '/checkup',
    },
    {
        name: 'marketing',
        to: '/marketing',
        icon: TwoUsersIcon,
        activeIcon: TwoUsersIcon,
        // requiresPermission: 'list_marketing',
    },
    {
        name: 'employees',
        icon: UsersIcon,
        activeIcon: UsersIcon,
        to: '/human-resources/employees',
    },
    {
        name: 'branches',
        icon: LocationIcon,
        activeIcon: LocationIcon,
        to: '/branches',
    },
    {
        name: 'finance',
        icon: CircleDollarSign,
        activeIcon: CircleDollarSign,
        to: '/finance',
        // requiresPermission: 'list_finance',
    },
    {
        name: 'reports',
        icon: BarChart3,
        activeIcon: BarChart3,
        to: '/reports',
        navigation: ReportsSide,
        // requiresPermission: 'list_report',
    },
    {
        name: 'permissions',
        icon: LocationIcon,
        activeIcon: LocationIcon,
        to: '/permissions-page',
        // requiresPermission: 'list_role',
    },

];
